<template>
  <VMenu
    :value="value"
    :close-on-content-click="false"
    offset-y
    left
    style="z-index: 999 !important"
    @input="$emit('input', $event)"
  >
    <template #activator="{ on }">
      <VBtn icon small class="elem-settings-btn" color="grey darken-3" v-on="on">
        <VIcon small color="white">settings</VIcon>
      </VBtn>
    </template>
    <VCard class="pa-3 elem-settings-controls">
      <slot />
      <div class="d-flex justify-space-between align-center mt-1">
        <VBtn
          flat
          small
          :color="confirmingDelete ? 'white' : 'red'"
          :class="{ red: confirmingDelete }"
          @click="$emit('delete')"
        >
          <VIcon small left>{{ confirmingDelete ? 'warning' : 'delete' }}</VIcon>
          {{ confirmingDelete ? 'Confirm' : 'Delete' }}
        </VBtn>
        <VBtn flat small @click="$emit('done')">Done</VBtn>
      </div>
    </VCard>
  </VMenu>
</template>

<script>
export default {
  name: 'LayoutElementSettingsMenu',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    confirmingDelete: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.elem-settings-btn {
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0;
  transition: opacity 0.15s;
}
.elem-settings-controls {
  min-width: 260px;
}
</style>
